export const ROUTES = {
  other: '*',
  index: '/',
  register: '/register',
  registerConfirm: '/register/confirm/:id/:code',
  registerError: '/register/error',
  home: '/home',
  dashboard: '/home/dashboard',
  portal: '/portal',
};

export const ROUTES_LIST = {
  registerConfirm: '/register/confirm',
  register: '/register',
  dashboard: '/home/dashboard',
  portal: '/portal',
}
